// import { Person } from './Person'
export class CalorieConsumption {
    /**
     * 
     * @param {Person} person 
     */
    constructor (person) {
        this.person = person
    }

    calcCalories() {
        return 0
    }


}

export class SleepCalorieConsumption extends CalorieConsumption {
    constructor (person, hours) {
        super(person)
        this.hours = parseInt(hours)
    }

    get calcCalories() {
        return ((10*this.person.weight + 6.25*this.person.height - 5*this.person.age + this.person.genfactor) * 0.95 * (this.hours/24)) || 0
    }
}

/**
 * @typedef {('FRAIL_PEOPLE'|'OFFICE_WORKERS'|'STUDENTS'|'CRAFTSMEN'|'HEAVY_WORKERS')} WorkType
 * defines different worktypes categorized by physical labor
 */

 export class WorkCalorieConsumption extends CalorieConsumption {
    static CONVERSION_TABLE = {
        FRAIL_PEOPLE: 1.25,
        OFFICE_WORKERS: 1.45,
        STUDENTS: 1.65,
        CRAFTSMEN: 1.85,
        HEAVY_WORKERS: 2.2
    }
    /**
     * 
     * @param {Person} person 
     * @param {Number} hours 
     * @param {WorkType} worktype 
     */
    constructor (person, hours, worktype) {
        super(person)
        this.hours = parseInt(hours)
        this.worktype = worktype
    }

    get palfactor() {
        return WorkCalorieConsumption.CONVERSION_TABLE[this.worktype] || 1
    }

    get calcCalories() {
        return ((10*this.person.weight + 6.25*this.person.height - 5*this.person.age + this.person.genfactor) * (this.palfactor) * (this.hours/24)) || 0
    }
}

/**
 * @typedef {('WALKING'|'CYCLING'|'SWIMMING'|'SKIING'|'TENNIS'|'TABLETENNIS'|'WEIGHTLIFTING'|'BADMINTON'|'SOCCER'|'VOLLEYBALL'|'BASKETBALL'|'HANDBALL'|'ICEHOCKEY'|'JUDO'|'GYMNASTICS'|'FENCING'|'BOXING'|'EXCERCISE')} SportType
 * defines different sporttypes and the intensity of this sporttype
 */

export class SportCalorieConsumption extends CalorieConsumption {
    static CONVERSION_TABLE = {
        WALKING: [9.775, 11.5, 14],
        CYCLING: [10.2, 12, 16],
        SWIMMING: [6.375, 7.5, 8.625],
        SKIING: [13.6, 16, 19],
        TENNIS: [6.375, 7.5, 8.625],
        TABLETENNIS: [4.505, 5.3, 6.095],
        WEIGHTLIFTING: [5.95, 7, 8.05],
        BADMINTON: [9.775, 11.5, 13.225],
        SOCCER: [10.2, 12, 13.8],
        VOLLEYBALL: [6.205, 7.3, 8.395],
        BASKETBALL: [13.77, 16.2, 18.63],
        HANDBALL: [11.9, 14, 16.1],
        ICEHOCKEY: [11.9, 14, 16.1],
        JUDO: [11.9, 14, 16.1],
        GYMNASTICS:[11.9, 14, 16.1],
        FENCING: [6.375, 7.5, 8.625],
        BOXING: [13, 16, 20],
        EXCERCISE: [2.975, 3.5, 4.025]

    }

    constructor (person, hoursObject, sporttype, intensity) {
        super(person)
        this.hoursObject = (hoursObject == null || typeof hoursObject == 'undefined') ? {} : hoursObject
        this.sporttype = (sporttype == null || typeof sporttype == 'undefined') ? [] : sporttype
        this.intensity = (intensity == null || typeof intensity == 'undefined') ? {} : intensity
    }

    get hoursPerDay () {
        let ob = {}
        for (let sport of this.sporttype) {
            ob[sport] = ((parseInt(this.hoursObject[sport]) / 60) / 7) || 0
        }
        return ob
    }

    get hours () {
        if ( Object.keys(this.hoursPerDay).length > 0) {
            return Object.values(this.hoursPerDay).reduce(function (acc, val) {
                return acc + val
            })
        } else {
            return 0
        }
    }

    getIntensity(sport) {
        let intensity = 1
        this.intensity[sport] < 33 ? intensity = 0 : intensity +=0
        this.intensity[sport] >= 33 && this.intensity[sport] < 66 ? intensity = 1 : intensity += 0
        this.intensity[sport] >= 66 ? intensity = 2 : intensity += 0
        return intensity
    }

    get calcCalories() {
        var total = 0
        for (let sport of this.sporttype) {
            total += this.hoursPerDay[sport] * this.person.weight * (SportCalorieConsumption.CONVERSION_TABLE[sport][this.getIntensity(sport)] || 10)
        }
        return total
}
}
export class RestCalorieConsumption extends CalorieConsumption {
    constructor (person, hours) {
        super(person)
        this.hours = hours
    }

    get calcCalories() {
        return ((10*this.person.weight + 6.25*this.person.height - 5*this.person.age + this.person.genfactor) * (this.hours/24)) || 0
    }
}